var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tool-bar", { attrs: { title: "Add Service Log" } }),
      _vm._v(" "),
      _c(
        "v-container",
        {
          staticClass: "page-container",
          class: { "mobile pa-4": _vm.isMobile, "py-4 px-5": _vm.isTablet }
        },
        [
          _c(
            "v-tabs",
            {
              staticClass: "student-tabs",
              class: { "show-arrows-outside": !_vm.isMobile && !_vm.isTablet },
              attrs: {
                slot: "extension",
                "show-arrows": "",
                color: "transparent",
                "hide-slider": ""
              },
              slot: "extension"
            },
            _vm._l(_vm.studentsArray, function(student, index) {
              return _c(
                "v-tab",
                { key: index, attrs: { disabled: index !== 0 } },
                [
                  _c("span", [
                    _vm._v(
                      "\n            " +
                        _vm._s(student.studentName) +
                        "\n            "
                    ),
                    _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            return _vm.onRemoveStudentClicked(student)
                          }
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          { attrs: { disabled: !_vm.showTooltip, top: "" } },
                          [
                            _c(
                              "v-icon",
                              {
                                class: { "white--text": _vm.tab === index },
                                attrs: { slot: "activator", size: "16" },
                                slot: "activator"
                              },
                              [
                                _vm._v(
                                  "\n                  clear\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Remove Student")])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("v-alert", { attrs: { value: _vm.errorMsg, type: "error" } }, [
            _vm._v("\n      " + _vm._s(_vm.errorMsg) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(_vm.studentsArray, function(student, index) {
              return _c(
                "v-tab-item",
                { key: index },
                [
                  _c("student-card", { attrs: { student: student } }),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    { attrs: { novalidate: "" } },
                    [
                      _c("service-log-form", {
                        attrs: {
                          arrayLength: _vm.studentsArray.length,
                          deliveryModeArray: _vm.deliveryModeArray,
                          groupTypeArray: _vm.groupTypeArray,
                          index: index,
                          loadData: _vm.loadData,
                          medicaidArray: _vm.medicaidArray,
                          absentTypesArray: _vm.absentTypesArray,
                          absentReasonsArray: _vm.absentReasonsArray,
                          absentAlternativesArray: _vm.absentAlternativesArray,
                          resetValidations: _vm.resetValidations,
                          serviceDeliveredArray: _vm.serviceDeliveredArray,
                          showTooltip: _vm.showTooltip,
                          student: student
                        },
                        on: {
                          "remove:student": function($event) {
                            return _vm.onRemoveStudentClicked(student)
                          },
                          "form:submitted": function($event) {
                            _vm.submitted = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLoading ? _c("full-screen-loading-spinner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86119590", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86119590","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/service-log/create-service-log.vue
// module id = null
// module chunks = 